import { OdataManager } from '@/api/odata/odata-manager';
import { PnrTitleObject } from '@/api/model/interfaces';

export default class PnrTitleObjectOdata extends OdataManager<PnrTitleObject> {}
